// Phase 5 (F-01): 燃料油価格の派生計算（純関数）。
// admin / 客向け HTML / functions のいずれからも参照されるため Web SDK / Node SDK 依存は持たない。
//
// 派生ルールは旧 admin.html の挙動を踏襲（issue F-01 実装メモ参照）:
// - 現金フリー価格    = basePrice2
// - キャッシュレス価格 = basePrice2 - 3
// - LINE 価格         = basePrice2 - LINE_DISCOUNT_BY_FUEL[fuelType]
//   - haioku: -6, regular: -7, keiyu: -8, touyu: -9
// - 掛売振込価格      = syukinPrice - 1
// - 掛売口座振替価格  = syukinPrice - 2
//
// F-16: 値引き幅はテナント別設定（fuel_settings/{tenantId}.pricing）で変更可能。
// F-16b: 各値引きは「全燃料共通 / 燃料別」の 2 モードを持つため、全 derive 関数が
// fuelType を取る（適用値の解決は resolveFuelDiscount）。`pricing` を省略すると
// DEFAULT_FUEL_PRICING（上記の従来ハードコード互換値）で計算するため既存挙動と一致する。
//
// すべて整数演算で完結（Math.floor / Math.round 不要）。
import { DEFAULT_FUEL_PRICING, resolveFuelDiscount, } from './fuelSettings.js';
/**
 * 燃料種別ごとの LINE 値引き額（円）のデフォルト。
 * F-16 以降の真実源は DEFAULT_FUEL_PRICING.line.byFuel（本 const はその別名 / 互換維持）。
 */
export const LINE_DISCOUNT_BY_FUEL = DEFAULT_FUEL_PRICING.line.byFuel;
/** 現金フリー価格（基準価格と同値）。 */
export function deriveCashFreePrice(basePrice2) {
    return basePrice2;
}
/** キャッシュレス価格 = 基準価格 - キャッシュレス値引き（既定 3 円 / 全燃料共通）。 */
export function deriveCashlessPrice(basePrice2, fuelType, pricing = DEFAULT_FUEL_PRICING) {
    return basePrice2 - resolveFuelDiscount(pricing.cashless, fuelType);
}
/** LINE 価格 = 基準価格 - LINE 値引き（既定は燃料別 -6/-7/-8/-9）。 */
export function deriveLinePrice(basePrice2, fuelType, pricing = DEFAULT_FUEL_PRICING) {
    return basePrice2 - resolveFuelDiscount(pricing.line, fuelType);
}
/** 会員価格（価格一覧表の印刷用）= 基準価格 - 会員値引き（既定 6 円 / 全燃料共通）。 */
export function deriveMemberPrice(basePrice2, fuelType, pricing = DEFAULT_FUEL_PRICING) {
    return basePrice2 - resolveFuelDiscount(pricing.member, fuelType);
}
/** 掛売振込価格 = 集金基準価格 - 掛売振込値引き（既定 1 円 / 全燃料共通）。 */
export function deriveKakeuriBankPrice(syukinPrice, fuelType, pricing = DEFAULT_FUEL_PRICING) {
    return syukinPrice - resolveFuelDiscount(pricing.kakeuriBank, fuelType);
}
/** 掛売口座振替価格 = 集金基準価格 - 掛売口座振替値引き（既定 2 円 / 全燃料共通）。 */
export function deriveKakeuriDirectDebitPrice(syukinPrice, fuelType, pricing = DEFAULT_FUEL_PRICING) {
    return syukinPrice - resolveFuelDiscount(pricing.kakeuriDirectDebit, fuelType);
}
//# sourceMappingURL=fuelPriceDerive.js.map